import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { SummarySheetGraphsCount } from '@/__generated__/graphql';
import { getCriticalityLevelColor } from '../shared/styles';

const DamageClassList = ({
  damageClassCounts,
}: {
  damageClassCounts: SummarySheetGraphsCount[];
}) => {
  return (
    <>
      {damageClassCounts.map((damageClassCount) => (
        <Stack direction="row" alignItems="center" key={damageClassCount.key}>
          <Box
            sx={{
              backgroundColor: getCriticalityLevelColor(damageClassCount.key ?? ''),
              width: '1rem',
              height: '1rem',
              borderRadius: '0.2rem',
              mr: 0.75,
            }}
          />
          <Typography fontSize="1.1rem" lineHeight="normal" color={abyssColors.primary[300]}>
            {damageClassCount.key}
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              height: '1px',
              backgroundColor: abyssColors.primary[100],
              mx: 2,
            }}
          />
          <Typography
            fontSize="1.4rem"
            fontWeight={500}
            lineHeight="normal"
            color={abyssColors.primary[400]}
          >
            {damageClassCount.count ?? 0}
          </Typography>
        </Stack>
      ))}
    </>
  );
};

export default DamageClassList;
